import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import './add-admin-users.css';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from "react-router-dom";
import http from '../../services/http-service';
import Backdrop from '@mui/material/Backdrop';
import { useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import checkValidationFormAllControls from '../../constants/validation';
import { getErrorResponse } from '../../utils';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function AddAdminUsers() {
  let query = useQuery();
  const userId = query.get('id')
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [countryCodeList, setCountryCodeList] = useState([])
  const [countryCode, setCountryCode] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmit, setIsSubmit] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [errorDisplay, seterrorDisplay] = useState('')


  useEffect(() => {
    fatchCountryCodes()
    if (query.get('id'))
      getUserData()
    // eslint-disable-next-line
  }, [])

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const goBack = () => {
    history.goBack()
  }

  const fatchCountryCodes = () => {
    handleToggle()
    http('account/phone_code_list/', 'GET')
      .then(res => {
        if (res.data.status) {
          setCountryCodeList(res.data.data)
        }
        else {
          toast.error(res.data.message,{
            toastId: 'request_failed'
          })

        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        })
  }

  const getUserData = () => {
    http('admin/edit_admin/' + query.get('id'), 'GET')
      .then(res => res.data)
      .then(res => {
        if (res.status) {
          setFirstName(res.data.first_name)
          setLastName(res.data.last_name)
          setEmail(res.data.email)
          setCountryCode(res.data.phonecode)
          setPhoneNumber(res.data.mobile)
        }
        else {
          const error = getErrorResponse(res.message)
          toast.error(error, { toastId: 'request_failed',allowHtml: true })
          // toast.error(res.message)
        }
        handleClose()
      })
      .catch(error => {
        toast.error("Something went wrong!",{
          toastId: 'catch_error'
        })
        handleClose()
      });
  }

  const submitForm = (event) => {
    event.preventDefault();
    setIsSubmit(true)
    var objValidation = {};
    objValidation = checkValidationFormAllControls(document.forms[0].elements, false, [])
    if (objValidation.valid !== false) {
      // debugger
      seterrorDisplay(objValidation);
      setIsSubmit(false)
      return;
    } else {
      // debugger
      seterrorDisplay(objValidation);
    }

    // const data = new FormData(event.currentTarget);
    const body = {
      id: userId ? userId : '',
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone_number: countryCode+phoneNumber,
    }
    let method = userId ? 'PUT' : 'POST'
    let apiUrl = userId ? 'admin/update_admin/' : 'admin/add_new_admin_user/'
    handleToggle()
    http(apiUrl, method, body)
      .then(res => res.data)
      .then(res => {
        if (res.status) {
          history.goBack()
          toast.success(res.message,{
            toastId: 'request_success'
          })
        }
        else {
          setIsSubmit(false)
          const error = getErrorResponse(res.message)
          toast.error(error, { toastId: 'request_failed', allowHtml: true })
          // toast.error(res.message)
        }
        handleClose()
      })
      .catch(error => {
        setIsSubmit(false)
        toast.error("Something went wrong!",{
          toastId: 'catch_error'
      })
        handleClose()
      });
  }

  return (

    <div className='mainAppDiv'>
      <ToastContainer />

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Typography variant="h3" className='AdminAddEmployerHeadding' gutterBottom component="div">
        {userId ? 'Edit' : 'Add'} Admin User
      </Typography>

      <form onSubmit={submitForm} noValidate sx={{ mt: 1 }} className="formInputHeight">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} >
            <TextField required fullWidth
              id="first_name" label="First Name" name="first_name" type="text"
              value={firstName} onChange={(e) => {
                setFirstName(e.target.value)
              }}
            />
            {errorDisplay.first_name ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.first_name}</span> : ''}
          </Grid>
          <Grid item xs={12} md={6} >
            <TextField required fullWidth
              name="last_name" label="Last Name" type="text" id="last_name"
              value={lastName} onChange={(e) => {
                setLastName(e.target.value)
              }}
            />
            {errorDisplay.last_name ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.last_name}</span> : ''}
          </Grid>
          <Grid item xs={12} md={6} >
            {/* <Typography display="block" gutterBottom>
              Email
            </Typography> */}
            <TextField required fullWidth disabled={userId}
              name="email" label="Email" type="email" id="email"
              value={email} onChange={(e) => {
                setEmail(e.target.value)
              }} />
            {errorDisplay.email ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.email}</span> : ''}
          </Grid>
          <Grid item xs={12} md={6} >
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <FormControl fullWidth className="cityHeight">
                  <InputLabel id="demo-simple-select-required-label">Code</InputLabel>
                  <Select
                    labelId="demo-simple-select-required-label"
                    id="country_code"
                    name='country_code'
                    value={countryCode}
                    label="Code*"
                    onChange={(event) => {
                      setCountryCode(event.target.value)
                    }}
                  >
                    <MenuItem value="" disabled="true">Please select</MenuItem>
                    {
                      countryCodeList.map((data, index) => (
                        <MenuItem key={'data.code' + index} value={data.code}>{data.name+" ("+data.code+")"}</MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <TextField required fullWidth name="mobile_phone"
                  label="Mobile Phone" type="text" id="mobile_phone"
                  value={phoneNumber} onChange={(e) => {
                    setPhoneNumber(e.target.value)
                  }} />
                {errorDisplay.mobile_phone ? <span style={{
                  fontSize: '14px',
                  color: '#dc0e0e'
                }}>{errorDisplay.mobile_phone}</span> : ''}
              </Grid>

            </Grid>


          </Grid>
        </Grid>

        {/* <div className='btnDiv'> */}
        <Grid container spacing={3} className='justifyEnd' sx={{ justifyContent: 'flex-end' }}>
          <Grid item xs={12} className='gridbtnSubmit'>
            <button type='button' className='btnSubmit btnCancel' onClick={goBack}>Cancel</button>
            <button type='submit' className='btnSubmit' disabled={isSubmit}>Submit</button>
          </Grid>
        </Grid>
        {/* </div> */}
      </form>
    </div>
  )
}

export default AddAdminUsers;
